// rules object met harde foutmeldingen in het Nederlands
export default {
  rules: {
    text_field_rules: {
      required: (value) => !!value || "Dit veld is verplicht.",
      isNumber: (value) => !isNaN(value) || "Dit veld moet een nummer zijn.",
      isYear: (value) => {
        const currentYear = new Date().getFullYear();
        return (
          (value.length === 4 &&
            /^\d+$/.test(value) &&
            value <= currentYear &&
            value !== "0000") ||
          "Vul een geldig jaar in."
        );
      },
      IsPositive: (value) => value >= 0 || "De waarde moet positief zijn.",
      isDateFormat: (value) => {
        if (!value) return "Dit veld is verplicht.";

        // Reguliere expressie voor het formaat dd/mm/yyyy
        const datePattern = /^([0-2][0-9]|3[01])\/(0[1-9]|1[0-2])\/\d{4}$/;
        if (!datePattern.test(value)) {
          return "De datum moet uitgeschreven worden in dd/mm/jjjj.";
        }

        // Controleer of de datum geldig is
        const [day, month, year] = value.split("/").map(Number);
        const date = new Date(year, month - 1, day);

        // Controleer of de onderdelen overeenkomen
        if (
          date.getFullYear() !== year ||
          date.getMonth() + 1 !== month ||
          date.getDate() !== day
        ) {
          return "Ongeldige datum. Controleer de dag, maand en jaar.";
        }

        return true; // Geldige datum
      },

      isEmail: (value) => {
        const emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
        return emailPattern.test(value) || "Vul een geldig e-mailadres in.";
      },
      is18YearsOrOlder: (value) => {
        if (!value) {
          return "Dit veld is verplicht.";
        }
        const enteredDate = new Date(value);
        if (isNaN(enteredDate)) {
          return "Vul een geldige datum in.";
        }
        const today = new Date();
        const ageDifference = today.getFullYear() - enteredDate.getFullYear();
        const hasHadBirthday =
          today.getMonth() > enteredDate.getMonth() ||
          (today.getMonth() === enteredDate.getMonth() &&
            today.getDate() >= enteredDate.getDate());
        const is18OrOlder =
          ageDifference > 18 || (ageDifference === 18 && hasHadBirthday);
        return is18OrOlder || "Je moet minimaal 18 jaar oud zijn.";
      },
    },
    radio_group_rules: {
      required: (value) => value !== null || "Dit veld is verplicht.",
    },
    select_rules: {
      required: (value) =>
        (value !== null && value !== undefined && value !== "") ||
        "Selecteer een optie.",
      minItems: (value) =>
        (Array.isArray(value) && value.length >= 2) ||
        "Selecteer minimaal twee items.",
    },
    priceEndRule(start, end) {
      const priceStart = parseFloat(start);
      const priceEnd = parseFloat(end);
      if (isNaN(priceStart) || isNaN(priceEnd)) {
        return true; // De vereiste regel behandelt lege velden
      }
      return (
        priceEnd >= priceStart ||
        "De eindprijs moet groter dan of gelijk zijn aan de startprijs."
      );
    },
  },
};
